module.exports = __webpack_public_path__ + "static/media/clinicIcon.c954f7a7.png";